import React, { Component } from "react";
import CtDtp from "./CustomTool/CtDtp";
import { Grid, Box } from "@mui/material";
import Progress from "./CustomTool/Progress";
import { getRowColData } from "../SystemUtility/SystemUtility";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtBtn from "./CustomTool/CtBtn";
import TableList from "./CustomTool/TableList";
import { get_YMD_from_SYS } from "../SystemUtility/SystemUtility";
import CtTxt from "./CustomTool/CtTxt";
import { Delete, Edit } from "@mui/icons-material";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
class ProductionMaster2 extends Component {
  state = {
    dataLoadStatus: true,
    columns: [
      { id: "Action", label: "", name: "" },
      { id: "vac_title", label: "Title", size: 100 },
      { id: "RM", label: "RM IC", size: 100 },
      { id: "FG", label: "FG IC", size: 100 },
    ],
    rows: [
      {
        vac_title: "Account",
        RM: "110",
        FG: "220",
      },
    ],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        // link: "ItemMaster:",
        // actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        // link: "ItemMaster:",
        // actionType: "AlertResponsive",
      },
    ],
    formData: {
      txtTitle: "",
    },
    rowsCount: 0,
    rowsPerPage: 50,

    columns2: [
      { id: "Action", label: "" },
      { id: "int_srno", label: "Sr No", width: 80 },
      {
        id: "vac_itemname",
        label: "Item Name",
        type: "CtCmb",
        CtrlProps: {
          maxLength: 100,
          width: 200,
          items: [
            { vac_itemname: "RM Item 1" },
            { vac_itemname: "RM Item 2" },
            { vac_itemname: "RM Item 3" },
          ],
          colID: "vac_itemname",
        },
      },
    ],
    rows2: [
      {
        int_srno: "1",
        vac_itemname: "",
      },
    ],
    rowsCount2: 0,
    rowsPerPage2: 50,

    columns3: [
      { id: "Action", label: "" },
      { id: "int_srno", label: "Sr No", width: 80 },
      {
        id: "vac_itemname",
        label: "Item Name",
        type: "CtCmb",
        CtrlProps: {
          maxLength: 100,
          width: 200,
          items: [
            { vac_itemname: "FG Item 1" },
            { vac_itemname: "FG Item 2" },
            { vac_itemname: "FG Item 3" },
          ],
          colID: "vac_itemname",
        },
      },
    ],
    rows3: [
      {
        int_srno: "1",
        vac_itemname: "",
      },
    ],
    rowsCount3: 0,
    rowsPerPage3: 50,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Production Master";
    this.props.setActiveMenu("ProductionMaster");
  }
  //#endregion Component

  //#region Handle

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnNewEntryClick = () => {
    if (this.valiadteToDoNote()) {
      this.newRow();
    }
  };

  handleOnNewEntryFGClick = () => {
    if (this.valiadteFGTable()) {
      this.newRowForFG();
    }
  };

  handleOnRowDataChange2 = (rows2, handledRowIndex, colID) => {
    this.setState({ rows2, rowsCount2: rows2.length });
  };

  handleOnRowDataChange3 = (rows3, handledRowIndex, colID) => {
    this.setState({ rows3, rowsCount3: rows3.length });
  };

  //#endregion Handle

  //#region Function

  newRow = (newRows, returnRows) => {
    const rows2 = newRows !== undefined ? newRows : this.state.rows2;
    rows2.push({
      vac_itemname: "",
      int_srno: (this.state.rows2.length + 1).toString(),
    });
    if (returnRows) {
      return rows2;
    } else {
      this.setState({
        rows2,
        rowsCount2: rows2.length,
      });
    }
  };

  valiadteToDoNote = () => {
    let errorCount = 0;
    let rows2 = this.state.rows2;
    rows2 = rows2.map((row, index) => {
      console.log("row", row.vac_itemname.length);
      errorCount++;
      if (row.vac_itemname.length <= 0) {
        this.props.toastErrorMsg(
          "Enter Data in Raw Material Table's Row " + (index + 1)
        );
      } else {
        errorCount--;
      }
    });
    return errorCount === 0;
  };

  newRowForFG = (newRows, returnRows) => {
    const rows3 = newRows !== undefined ? newRows : this.state.rows3;
    rows3.push({
      vac_itemname: "",
      int_srno: (this.state.rows3.length + 1).toString(),
    });
    if (returnRows) {
      return rows3;
    } else {
      this.setState({
        rows3,
        rowsCount3: rows3.length,
      });
    }
  };

  valiadteFGTable = () => {
    let errorCount = 0;
    let rows3 = this.state.rows3;
    rows3 = rows3.map((row, index) => {
      errorCount++;
      if (row.vac_itemname.length <= 0) {
        this.props.toastErrorMsg(
          "Enter Data in Finish Goods Table's Row " + (index + 1)
        );
      } else {
        errorCount--;
      }
    });
    return errorCount === 0;
  };

  SaveProduction = () => {
    if (this.validateProduction()) {
      alert("Save Production");
    }
  };

  deleteProduction = () => {
    alert("Delete Work For Production Is Pending...");
  };

  validateProduction = () => {
    let result = false;
    if (this.state.formData.txtTitle.length <= 0) {
      this.props.toastErrorMsg("Enter Title", "txtTitle");
    } else {
      result = true;
    }
    return result;
  };

  clearInfo = () => {
    const txtTitle = "";
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtTitle,
        },
      },
      () => {
        document.getElementById("txtTitle").focus();
      }
    );
  };

  //#endregion Funtion

  render() {
    // let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    // let rowsCount = this.state.searchOpen
    //   ? this.state.searchRowsCount
    //   : this.state.rowsCount;
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b> Production Master </b>
          </label>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Grid item>
            <CtTxt
              id="txtTitle"
              value={this.state.formData.txtTitle}
              label="Title*"
              handleOnChange={this.handleOnChange}
              width={300}
              maxLength={100}
            />
          </Grid>
          <Grid item>
            <CtBtn label="Save" onClick={this.SaveProduction} />
          </Grid>
          <Grid item>
            <CtBtn label="New" onClick={this.clearInfo} />
          </Grid>
          <Grid item>
            <CtBtn label="Delete" onClick={this.deleteProduction} />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          marginTop={2}
          spacing={2}
        >
          <Grid item lg={6}>
            <label>
              <b>Raw Material Table</b>
            </label>

            <TableList
              columns={this.state.columns2}
              rows={this.state.rows2}
              rowsCount={this.state.rowsCount2}
              rowsPerPage={this.state.rowsPerPage2}
              handleOnNewEntryClick={this.handleOnNewEntryClick}
              //   handleOnActionClick={this.handleARDonActionClick}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              //   actionList={this.state.actionList}
              keyColumn={this.state.keyColumn}
              handleOnRowDataChange={this.handleOnRowDataChange2}
            />
          </Grid>

          <Grid item lg={6}>
            <label>
              <b>Finish Goods Table</b>
            </label>

            <TableList
              columns={this.state.columns3}
              rows={this.state.rows3}
              rowsCount={this.state.rowsCount3}
              rowsPerPage={this.state.rowsPerPage3}
              handleOnNewEntryClick={this.handleOnNewEntryFGClick}
              //   handleOnActionClick={this.handleARDonActionClick}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              //   actionList={this.state.actionList}
              keyColumn={this.state.keyColumn}
              handleOnRowDataChange={this.handleOnRowDataChange3}
            />
          </Grid>

          <Grid item lg={12} marginTop={2}>
            <label>
              <b>Production Master List</b>
            </label>
            <TableList
              columns={this.state.columns}
              counter={this.state.counter}
              rows={this.state.rows}
              rowsCount={this.state.rowsCount}
              rowsPerPage={this.state.rowsPerPage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              handleOnActionClick={this.handleARDonActionClick}
              actionList={this.state.actionList}
              keyColumn={this.state.keyColumn}
            />
          </Grid>
        </Grid>

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default HoCtToastContainer(ProductionMaster2);
